import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

/**
 * Indicator icon
 *
 * @displayName Indicator (Web)
 * @class Indicator
 * @public
 */
export default function Indicator({ icon, background }) {
  if (!(!!icon && !!background)) return null;
  const Icon = icon;

  return (
    <div className={ classnames(background, 'panel-indicator') }>
      <Icon />
    </div>
  );
}

Indicator.propTypes = {
  /** Name of the icon to display. */
  icon: PropTypes.elementType,
  /** Background class to use. */
  background: PropTypes.string
};
